module.exports = __webpack_public_path__ + "img/14-fourImg.3f017eec.png";